import { DisciplineOptions } from '@generated';
import { X } from 'lucide-react';
import { Button } from '~/shared/components/buttons/Button';
import { SelectFormField } from '~/shared/forms/controls/fields/SelectFormField';
import { TextFormField } from '~/shared/forms/controls/fields/text-fields/TextFormField';
import { useEditFrequencies } from './EditFrequenciesContext';

export function EditPrnFrequencies() {
	const {
		wizardState: { draftPrnFrequencies },
		dispatch
	} = useEditFrequencies();
	return (
		<>
			{draftPrnFrequencies.map((x, index) => (
				<div key={x.id} className="flex items-center justify-between gap-2 rounded border border-gray-300 bg-gray-50 p-2">
					<div className="grid grid-cols-4 gap-2 py-2">
						<SelectFormField name={`draftPrnFrequencies[${index}].disciplineId`} options={DisciplineOptions} />
						<TextFormField name={`draftPrnFrequencies[${index}].count`} />
						<TextFormField name={`draftPrnFrequencies[${index}].prnReason`} className="col-span-2" />
					</div>
					<Button
						Icon={X}
						appearance="outline"
						intent="destructive"
						onClick={() => dispatch({ type: 'REMOVE_DRAFT_PRN_FREQUENCY', frequencyId: x.id })}
						aria-label="Remove PRN Frequency"
					/>
				</div>
			))}
			<div className="flex justify-end">
				<Button
					appearance="outline"
					actionType="add"
					label="Add PRN"
					onClick={() =>
						dispatch({
							type: 'ADD_DRAFT_PRN_FREQUENCY'
						})
					}
				/>
			</div>
		</>
	);
}
